import Component from "./EditTid";
export default Component;
